/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess.ts";

function getPutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessUrl(
  courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/course-access` as const,
  };
  return res;
}

/**
 * @description Atualiza as configurações de acesso ao curso. Quando liberado com ReleasedUntil, o acesso expira ao fim do dia informado. Quando liberado sem ReleasedUntil, o acesso expira após ReleasedDays dias (padrão 30). A data de liberação não pode ser menor que hoje. Quando bloqueado, limpa todos os campos de liberação. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Salva o acesso ao curso de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/course-access}
 */
export async function putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess(
  courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"],
  data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
    >,
    PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessUrl(
      courseRegistrationId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
